module.exports = __webpack_public_path__ + "static/media/clue-7.0c410a4e.svg";